import { ResultOf } from "@graphql-typed-document-node/core";
import { createContext } from "react";
import { CombinedError } from "urql";

import { graphql } from "@/gen";

export const ViewerContext_Viewer = graphql(`
    fragment ViewerContext_Viewer on Viewer {
        id
        firebaseId
        isEditor
        permissions
        commentator {
            id
            displayName
            imageId
            countryCode
        }
    }
`);

export type ViewerContextType = {
    viewer?: ResultOf<typeof ViewerContext_Viewer>;
    loading: boolean;
    error: CombinedError | undefined;
    refetch: () => Promise<void>;
};

export const ViewerContext = createContext<ViewerContextType | null>(null);
